export default __webpack_public_path__ + "static/media/cscf-logo-trans.c1465b64.png";